<template>
  <div class="unpaid">
    <!-- 查询条件 -->
    <vab-query-form>
      <vab-query-form-left-panel :span="18">
        <el-form inline>
          <el-form-item label="推荐人姓名">
            <el-input v-model="queryParams.likeName" clearable placeholder="请输入推荐人姓名" @change="query(1)" />
          </el-form-item>
          <el-form-item label="推荐人手机号">
            <el-input v-model="queryParams.phone" clearable placeholder="请输入推荐人手机号" @change="query(1)" />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="queryParams.status" clearable placeholder="请选择状态" @change="query(1)">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-form>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="6">
        <el-button icon="search" type="primary" @click="query()">查询</el-button>
        <el-button icon="refresh" type="warning" @click="reset">重置</el-button>
      </vab-query-form-right-panel>
    </vab-query-form>

    <!-- 表格 -->
    <el-table v-loading="loading" border :data="tableData" :table-layout="'auto'">
      <el-table-column label="推荐人姓名" prop="recommenderName" />
      <el-table-column label="推荐人手机号" prop="recommenderPhone" />
      <el-table-column :formatter="() => '银行卡'" label="收款类型" />
      <el-table-column label="收款账号" prop="bankCard" />
      <el-table-column label="银行" prop="bankName" />
      <el-table-column label="开户行信息" prop="openingBank" />
      <el-table-column label="待支付金额">
        <template #default="{ row }">{{ row.rewardAmount }}元</template>
      </el-table-column>
      <el-table-column label="项目编号" prop="outJobCode" />
      <el-table-column label="状态">
        <template #default="{ row }">
          {{ WITHDRAWAL_STATUS_CN[row.status] }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" :width="160">
        <template #default="{ row }">
          <!-- :disabled="row.status !== WITHDRAWAL_STATUS.PENDING" -->
          <el-link type="primary" :underline="false" @click="payStatusModal.open(row)">更改状态</el-link>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      v-model:current-page="queryParams.pageNum"
      background
      layout="prev, pager, next"
      :page-size="queryParams.pageSize"
      :total="queryParams.total"
      @current-change="query"
    />

    <!-- 审批 -->
    <el-dialog
      destroy-on-close
      :model-value="payStatusModal.visible"
      title="查看详情"
      :width="480"
      @close="payStatusModal.close()"
    >
      <PayStatusForm ref="payStatusFormRef" :data="payStatusModal.data" @success="onSuccess" />
      <template #footer>
        <el-button @click="payStatusModal.close()">取消</el-button>
        <el-button type="primary" @click="payStatusFormRef.submit()">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
  import { ref, reactive, onMounted } from 'vue'
  import { getRewardPay } from '@/api/recruitment'
  import { omit, pick } from 'lodash'
  import { useModal } from '@/hooks/useModal'
  import PayStatusForm from './PayStatusForm.vue'
  import { WITHDRAWAL_STATUS, WITHDRAWAL_STATUS_CN } from '../context'

  const payStatus = [
    WITHDRAWAL_STATUS.PENDING,
    WITHDRAWAL_STATUS.PAID,
    WITHDRAWAL_STATUS.PAY_ERROR,
    WITHDRAWAL_STATUS.BANK_REJECTED,
  ]

  const statusOptions = Object.entries(pick(WITHDRAWAL_STATUS_CN, ...payStatus)).map(([k, v]) => ({
    value: k,
    label: v,
  }))

  const defaultQueryParams = {
    phone: '',
    likeName: '',
    status: '',
    pageNum: 1,
    pageSize: 20,
    total: 0,
  }

  const queryParams = reactive({ ...defaultQueryParams })

  const loading = ref(false)
  const tableData = ref([])

  onMounted(() => {
    query()
  })

  function query(pageNum = queryParams.pageNum) {
    const params = {
      ...omit(queryParams, 'total'),
      pageNum,
    }

    loading.value = true

    getRewardPay(params)
      .then(({ code, data }) => {
        if (code !== 200) return
        const { list, total } = data
        tableData.value = list
        queryParams.total = total
      })
      .finally(() => {
        loading.value = false
      })
  }

  function reset() {
    for (const k in defaultQueryParams) {
      queryParams[k] = defaultQueryParams[k]
    }
    query(1)
  }

  const payStatusModal = useModal()
  const payStatusFormRef = ref()

  function onSuccess() {
    payStatusModal.close()
    query()
  }
</script>

<style lang="scss" scoped>
  .unpaid {
    padding: 16px;
  }
</style>
